/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import propTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import _ from 'lodash';
import {SELECTOR_DESIGN_CODE} from '../../redux/selectors/designs';
import {getDesignByCode} from '../../redux/actions/designs';
import api from '../../services/api';
import * as actions from '../../redux/actions';
import {COMPONENTS} from './constants';

MakeDBComponent.propTypes = {
  code: propTypes.string.isRequired,
};

export function MakeDBComponent({code}) {
  const [props, setProps] = useState({});
  const [loading, setLoading] = useState(true);

  const component = useSelector(SELECTOR_DESIGN_CODE(code));

  const dispatch = useDispatch();

  async function processCommand(rawCommand) {
    const [command, ...options] = rawCommand.split('::');
    switch (command) {
      case 'component':
        const componentId = options[0];
        const componentObject = component.data.components[componentId];
        if (COMPONENTS[componentObject?.component]) {
          const {component, props} = componentObject;
          const element = COMPONENTS[component];
          const elementProps = props ? await processProp(props) : {};
          return (props) =>
            React.createElement(element, _.merge({}, props, elementProps));
        }
        return rawCommand;
      case 'query':
        const queryName = options[0];
        const queryObject = component.data.queries[queryName];
        if (queryObject) {
          const {service, query} = queryObject;
          return await api[service].find({query}).then((it) => it.data);
        }
        return rawCommand;
      case 'action':
        const actionName = options[0];
        const actionObject = component.data.actions[actionName];
        if (actionObject) {
          const {name, args} = actionObject;
          return await dispatch(actions[name](...args));
        }
        return rawCommand;
      default:
        return rawCommand;
    }
  }

  async function processProp(value) {
    if (Array.isArray(value)) {
      const copyValue = JSON.parse(JSON.stringify(value));
      for (let i = 0; i < copyValue.length; i++) {
        copyValue[i] = await processProp(copyValue[i]);
      }
      return copyValue;
    } else if (typeof value === 'object') {
      const copyValue = JSON.parse(JSON.stringify(value));
      for (const valueKey in copyValue) {
        // noinspection JSUnfilteredForInLoop
        copyValue[valueKey] = await processProp(copyValue[valueKey]);
      }
      return copyValue;
    } else if (typeof value === 'string') {
      return await processCommand(value);
    } else {
      return value;
    }
  }

  useEffect(() => {
    if (component?.id) {
      processProp(component.data.props).then((props) => {
        setProps(props);
        setLoading(false);
      });
    }
  }, [component?.id]);

  useEffect(() => {
    if (code && !component) {
      dispatch(getDesignByCode(code)).then((data) => {
        if (!data.length) {
          //error
        }
      });
    }
  }, [code]);

  if (loading) {
    return <div />;
  }

  return React.createElement(COMPONENTS[component.component], props);
}
